export const ADD_NEW_DESIGN_TO_CART_DIMENSION =
  'Checkout Summary Add New Design';
export const ADD_NEW_DESIGN_TO_CART_QUERY_STRING = 'addtocart';
export const EDIT_DESIGN_FROM_CART_DIMENSION = 'Checkout Summary Edit Design';
export const EDIT_DESIGN_FROM_CART_QUERY_STRING = 'editfromcart';
export const EDIT_DESIGN_FROM_CART_CONTENT_WARNING_DIMENSION =
  'Checkout Summary Content Ownership Modal';
export const EDIT_DESIGN_FROM_CART_CONTENT_WARNING_QUERY_STRING =
  'editfromcartcontentwarning';
